import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import Select from 'react-select';

import { getAll } from '../../../../../../_actions/group.actions';

export default function LocationOptions({ form, locationChanged }) {
  const groups = useSelector(state => state.group.collection);
  const [groupSelected, setGroupSelected] = useState(form.providerGroup.id)

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAll());
  }, [dispatch]);

  if (groups.length === 0) {
    return <Spinner animation="border" role="status">
      <span className="sr-only">Loading...</span>
    </Spinner>
  }

  const groupOptions = groups.map((group) => {
    return { value: group.id, label: group.name }
  });

  const groupOptionSelected = groupOptions.find((group) => {
    return group.value === groupSelected;
  });

  return <Select
    options={groupOptions}
    onChange={(selected) => {
      locationChanged(selected.value);
      setGroupSelected(selected.value);
    }}
    value={groupOptionSelected || ''}
  />
}